import React, { useState, useEffect } from 'react';
import { listarProdutos } from '../../services/api';
import { Package, TrendingUp, Eye } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalProdutos: 0,
    categorias: 0
  });

  useEffect(() => {
    carregarEstatisticas();
  }, []);

  const carregarEstatisticas = async () => {
    try {
      const produtos = await listarProdutos();
      const categorias = [...new Set(produtos.map(p => p.categoria))];
      
      setStats({
        totalProdutos: produtos.length,
        categorias: categorias.length
      });
    } catch (error) {
      console.error('Erro ao carregar estatísticas:', error);
    }
  };

  return (
    <div className="admin-dashboard">
      <h2 className="admin-page-title">Dashboard</h2>
      
      <div className="admin-stats-grid">
        <Card className="stat-card">
          <CardContent className="stat-content">
            <div className="stat-icon" style={{ backgroundColor: '#ff8c19' }}>
              <Package size={32} color="white" />
            </div>
            <div className="stat-info">
              <p className="stat-label">Total de Produtos</p>
              <h3 className="stat-value">{stats.totalProdutos}</h3>
            </div>
          </CardContent>
        </Card>

        <Card className="stat-card">
          <CardContent className="stat-content">
            <div className="stat-icon" style={{ backgroundColor: '#4CAF50' }}>
              <TrendingUp size={32} color="white" />
            </div>
            <div className="stat-info">
              <p className="stat-label">Categorias</p>
              <h3 className="stat-value">{stats.categorias}</h3>
            </div>
          </CardContent>
        </Card>

        <Card className="stat-card">
          <CardContent className="stat-content">
            <div className="stat-icon" style={{ backgroundColor: '#2196F3' }}>
              <Eye size={32} color="white" />
            </div>
            <div className="stat-info">
              <p className="stat-label">Site Público</p>
              <a href="/" target="_blank" rel="noopener noreferrer" className="stat-link">
                Ver Site
              </a>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="admin-welcome">
        <h3>Bem-vindo ao Painel Administrativo!</h3>
        <p>Aqui você pode gerenciar todos os aspectos do site Mordida de Sonho:</p>
        <ul>
          <li><strong>Produtos:</strong> Adicionar, editar ou remover produtos</li>
          <li><strong>Feedbacks:</strong> Aprovar ou reprovar avaliações dos clientes</li>
          <li><strong>Galeria:</strong> Adicionar trabalhos realizados</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminDashboard;
